

























































import { Component, Vue, Prop, Provide, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import ValidationService from "../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../inversify.config";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import { ContentSetModel } from "../../models/content/content-set.model";

const ProductModule = namespace("productModule");
const ContentSetModule = namespace("contentSetModule");

@Component({
    components: {}
})
export default class ContentSetCreator extends Vue {
    @ProductModule.Action public retrieveProductCategories;
    @ProductModule.Getter public productCategories;
    @ContentSetModule.Action public createContentSet;
    @ContentSetModule.Getter public contentSet;

    @Provide() public options = [];
    @Provide() public contentSetModel: IContentSet = new ContentSetModel();
    @Provide() public show: boolean = false;

    public showModal() {
        this.show = true;
    }

    public hideModal() {
        this.show = false;
        this.resetModal();
    }

    public resetModal() {
        this.contentSetModel = new ContentSetModel();
    }

    public getValidationClass(fieldName: string) {
        return container
            .get<ValidationService>(ValidationService)
            .getValidationClass(this.$validator, fieldName);
    }

    public populateOptions() {
        this.retrieveProductCategories().then((result) => {
            this.options = this.productCategories.map((val) => ({
                value: val.productCategoryId,
                text: val.name
            }));
        });
    }

    public created() {
        this.populateOptions();
    }

    private submitForm() {
        this.$validator.validateAll().then((valid) => {
            if (valid) {
                this.createContentSet(this.contentSetModel).then((value) => {
                    if (value) {
                        this.hideModal();
                        this.$router.push({
                            name: "Content Set",
                            params: { id: this.contentSet.contentSetId }
                        });
                    }
                });
            }
        });
    }
}
